import React, { useState } from "react";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CompareProvider } from "./contexts/CompareContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { ProgressLine } from "./components/ProgressLine";
import { FeaturedSection, AccessGallery } from "./components/AccessGallery";
import { CoachSelector } from "./components/CoachSelector";
import { ScratchCard } from "./components/ScratchCard";
import { HowItWorks } from "./components/HowItWorks";
import { Reviews } from "./components/Reviews";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import { ProductModal } from "./components/ProductModal";
import { VideoModal } from "./components/VideoModal";
import { CompareDrawer } from "./components/CompareDrawer";
import { SupportBubble } from "./components/SupportBubble";
import { MobileStickyCTA } from "./components/MobileStickyCTA";

function App() {
  const [productModal, setProductModal] = useState(null);
  const [videoModal, setVideoModal] = useState(null);
  const [soundOn, setSoundOn] = useState(false);

  const openProduct = (id) => setProductModal(id);
  const playVideo = (id) => setVideoModal(id);

  return (
    <LanguageProvider>
      <CompareProvider>
        <div className="App relative min-h-screen bg-[#0a0b0f] text-[#F5F1EA] overflow-x-hidden">
          <Header soundOn={soundOn} setSoundOn={setSoundOn} />
          <ProgressLine />

          <main>
            <Hero />
            <FeaturedSection onOpen={openProduct} onPlay={playVideo} />
            <AccessGallery onOpen={openProduct} onPlay={playVideo} />
            <CoachSelector onOpen={openProduct} onPlay={playVideo} />
            <ScratchCard />
            <HowItWorks />
            <Reviews />
            <FAQ />
          </main>

          <Footer />

          <SupportBubble />
          <MobileStickyCTA />

          <ProductModal openId={productModal} onClose={() => setProductModal(null)} onPlay={playVideo} />
          <VideoModal openId={videoModal} onClose={() => setVideoModal(null)} />
          <CompareDrawer onOpen={openProduct} />
        </div>
      </CompareProvider>
    </LanguageProvider>
  );
}

export default App;
